export function getIsNative() {
  return typeof window === 'undefined' || !window.location
}
